import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { useIdleTimer } from 'react-idle-timer';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signOutUser } from '../../slices/AuthSlice';
import { useAppDispatch, useAppSelector } from '../../slices/store';
import { cn } from '../../utils/classUtils';

export const IDLE_WARNING_TIME = 10 * 60 * 1000;
export const AUTO_LOGOUT_TIME = 15 * 60 * 1000;

const IdleModal = () => {
  const { authUserDetail } = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);

  const timeUntilLogout = Math.floor(
    (AUTO_LOGOUT_TIME - IDLE_WARNING_TIME) / (60 * 1000),
  );

  const handleLogout = async () => {
    setShowModal(false);
    await dispatch(signOutUser());
    navigate('/login');
  };

  const { reset } = useIdleTimer({
    timeout: AUTO_LOGOUT_TIME,
    promptBeforeIdle: AUTO_LOGOUT_TIME - IDLE_WARNING_TIME,
    onPrompt: () => {
      setShowModal(true);
    },
    onIdle: () => {
      handleLogout();
    },
    crossTab: true,
    syncTimers: 1000,
  });

  if (!showModal) {
    return null;
  }

  return (
    <div className='fixed inset-0 z-50 w-full h-full-window'>
      <div className='absolute inset-0 z-0 bg-black bg-opacity-40' />
      <div className='flex items-center justify-center w-full h-full p-4 lg:p-0'>
        <div
          className={cn(
            'w-full md:w-3/5 lg:w-1/3 bg-white rounded-2xl z-10 shadow-zen-web scrollbar overflow-y-auto',
          )}
        >
          <div className='w-full p-6 md:p-10'>
            <div className='w-16 h-16 rounded-full bg-reskin-yellow-100 flex justify-center items-center mx-auto mb-6'>
              <FontAwesomeIcon
                icon={faTriangleExclamation}
                className='text-2xl text-reskin-yellow-900'
              />
            </div>
            <p className='text-lg md:text-[34px] font-poppins-semibold text-center text-primary-dark'>
              Hi {authUserDetail?.firstName},
            </p>
            <p className='text-lg md:text-[34px] font-poppins-semibold text-center -mt-1 md:mt-3 text-primary-dark'>
              are you still there?
            </p>
            <p className='text-center text-sm md:text-lg text-primary-dark md:leading-6 mb-6 md:mt-5 mt-2 px-10 md:px-0'>
              For your account&apos;s security, you&apos;ll be automatically
              signed out in {timeUntilLogout}{' '}
              {timeUntilLogout === 1 ? 'minute' : 'minutes'}.
            </p>
            <button
              className='bg-primary-mint rounded-lg text-base mx-auto p-2 text-center cursor-pointer w-full md:mt-8'
              onClick={() => {
                reset();
                setShowModal(false);
              }}
            >
              Yes! I&apos;m Here
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IdleModal;
